import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { SelectInput } from "../inputs/select-input"

interface SelectFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof SelectInput>, "value" | "onChange" | "error"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
  nullable?: boolean
}

export function SelectField<T extends FieldValues>({
  field,
  id,
  description,
  nullable,
  ...props
}: SelectFieldProps<T>) {
  const { error } = useFormField()
  return (
    <FormItem>
      <FormControl>
        <SelectInput
          id={id}
          value={field.value}
          onChange={field.onChange}
          error={!!error}
          nullable={nullable}
          {...props}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  category: string;
}

<FormField
  control={form.control}
  name="category"
  render={({ field }) => (
    <SelectField<FormData>
      field={field}
      id="category-select"
      label="Category"
      placeholder="Select a category"
      description="Choose a category from the list"
      options={[
        { value: "1", label: "Category 1" },
        { value: "2", label: "Category 2" },
      ]}
    />
  )}
/>
*/
